<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>View Customer Contract</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate()"
                                    class="p-button-success p-mr-2"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- form Contract Start -->
                    <div class="form-container scroll-y">
                        <form [formGroup]="_CostingContract">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Customer Site</td>
                                    <td colspan="3">
                                        <p-autoComplete formControlName="_customername" [suggestions]="listCustomername"
                                            (completeMethod)="filterCustomername($event)" field="customerName"
                                            (onSelect)="selectCustomerName()">
                                            <ng-template let-customer pTemplate="item">
                                                <div>{{customer.customerName}}</div>
                                            </ng-template>
                                        </p-autoComplete>
                                    </td>
                                    <td class="text-right">Contract Date</td>
                                    <td>
                                        <p-calendar [showIcon]="true" formControlName="contractdate" disabled="true"
                                        inputId="icon"></p-calendar>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">Minimum Freight Charges <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="minimumfreight" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumfreight').errors?.ContractRequired">
                                            Please Enter the Minimum Freight Charges
                                        </span>
                                    </td>
                                    <td class="text-right">Minimum Chargeable Weight <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="minimumchargeableweight" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumchargeableweight').errors?.ContractRequired">
                                            Please Enter the Minimum Chargeable Weight
                                        </span>
                                    </td>
                                    <td class="text-right">Minimum DC Charges <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" formControlName="minimumdc" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumdc').errors?.ContractRequired">
                                            Please Enter the Minimum DC Charges
                                        </span>
                                    </td>
                                </tr>
                                <tr>

                                    <td class="text-right">Minimum VSC Charges <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="minimumvsc" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumvsc').errors?.ContractRequired">
                                            Please Enter the Minimum VSC Charges
                                        </span>
                                    </td>
                                    <td class="text-right">Billing Branch <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" formControlName="billingbranchcode" [disabled]="true"
                                            placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                            optionLabel="branchname" optionValue="branchcode"></p-dropdown>
                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('billingbranchcode').errors?.ContractRequired">
                                            Please Select the Billing Branch
                                        </span>
                                    </td>
                                    <td class="text-right">Business Start Date<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" disabled="true" formControlName="businessstartdate" pInputText>
                                    </td>
                                </tr>
                                <tr>

                                    <td class="text-right">Fuel Price Per Ltr <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" formControlName="fuelpriceperltr" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('fuelpriceperltr').errors?.ContractRequired">
                                            Please Enter the Fuel Price Per Ltr
                                        </span>
                                    </td>
                                    <td class="text-right">Quoted Qtl Per KM<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" formControlName="quotedrateperqtlperkm" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('quotedrateperqtlperkm').errors?.ContractRequired">
                                            Please Enter the Quoted Qtl Per KM
                                        </span>
                                    </td>
                                    <td class="text-right">Present Fuel Rate<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" formControlName="presentfuelrate" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('presentfuelrate').errors?.ContractRequired">
                                            Please Enter the Present Fuel Rate
                                        </span>
                                    </td>

                                </tr>
                                <tr>
                                    <td class="text-right">Contract From Date</td>
                                    <td>
                                        <p-calendar [showIcon]="true" formControlName="contractfromdate" dateFormat="dd/mm/yy" disabled="true"
                                        inputId="icon"></p-calendar>
                                    </td>
                                    <td class="text-right">Contract To Date</td>
                                    <td>
                                        <p-calendar [showIcon]="true" formControlName="contracttodate" dateFormat="dd/mm/yy" disabled="true"
                                        inputId="icon"></p-calendar>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>

                              
                            </table>
                        </form>
                       
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>DD Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <form [formGroup]="_CostingContract">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Minimum DD Charges <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="minimumdd" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumdd').errors?.ContractRequired">
                                            Please Enter the Minimum DD Charges
                                        </span>
                                    </td>
                                    <td class="text-right"> Minimum Article <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (focusout)="onchangecosttocompanyDD()" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)" formControlName="minarticledd"
                                            pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minarticledd').errors?.ContractRequired">
                                            Please Enter the Minimum Article
                                        </span>
                                    </td>
                                    <td class="text-right">Cost to company (%) <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (focusout)="onchangecosttocompanyDD()" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)"
                                            formControlName="costtocompanydd" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('costtocompanydd').errors?.ContractRequired">
                                            Please Enter the Cost to company DD
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">Cost to Agent (%) <span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" disabled (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="costtoagentdd" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('costtoagentdd').errors?.ContractRequired">
                                            Please Enter the Cost to Agent DD
                                        </span>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </form>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>AC Charges</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <form [formGroup]="_CostingContract">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Minimum AC Charges <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="minimumac" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('minimumac').errors?.ContractRequired">
                                            Please Enter the Minimum AC Charges
                                        </span>
                                    </td>
                                    <td class="text-right">Cost to company (%) <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" (focusout)="onchangecosttocompanyAC()" disabled="true"
                                            (keypress)="keypress.kpDecimalInput($event)"
                                            formControlName="costtocompanyac" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('costtocompanyac').errors?.ContractRequired">
                                            Please Enter the Cost to company AC
                                        </span>
                                    </td>
                                    <td class="text-right">Cost to Agent (%) <span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" disabled (keypress)="keypress.kpDecimalInput($event)" disabled="true"
                                            formControlName="costtoagentac" pInputText>

                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('costtoagentac').errors?.ContractRequired">
                                            Please Enter the Cost to Agent AC
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </form>


                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Contract</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <!-- <form [formGroup]="_CostingContract">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">
                                        Contract Type<span class="hlt-txt">*</span>
                                    </td>
                                    <td>

                                        <p-multiSelect [options]="_ContractType" formControlName="contracttypescode"
                                            placeholder="Select" [filter]="true" [(ngModel)]="_ContractTypes"
                                            optionValue="metasubcode" optionLabel="metasubdescription"
                                            (onChange)="ChangeContractType($event)"></p-multiSelect>
                                        <span class="text-danger"
                                            *ngIf="(_CostingContractsubmitted) && _CostingContract.get('contracttypescode').errors?.ContractRequired">
                                            Please Select the Contract Type
                                        </span>
                                    </td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </form> -->
                        <p-tabView [(activeIndex)]="selectedtabContract">
                            <p-tabPanel header="General" *ngIf="HideGeneralRate">
                                <form [formGroup]="_CustomerSiteContractGeneralForm">
                                    <table class="normal-table">
                                        <tr>
                                            <td class="text-right">Rate Per Quintal/KM <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <input type="text" formControlName="rateperqtlperkm" disabled="true"
                                                    (keypress)="keypress.kpDecimalInput($event)" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_CustomerSiteContractGeneralFormsubmitted) && _CustomerSiteContractGeneralForm.get('rateperqtlperkm').errors?.ContractRequired">
                                                    Please Enter the Rate Per Quintal/KM
                                                </span>
                                            </td>
                                            <td class="text-right">ODA Calculation Mode <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-formgroup-inline">
                                                    <div class="p-field-radiobutton"
                                                        *ngFor="let PF of _ODACalculationMode">
                                                        <p-radioButton name="odacalculationmodecode" disabled="true"
                                                            formControlName="odacalculationmodecode"
                                                            label={{PF.metasubdescription}} inputIt="PF.metasubcode"
                                                            value={{PF.metasubcode}}>
                                                        </p-radioButton>
                                                    </div>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_CustomerSiteContractGeneralFormsubmitted) && _CustomerSiteContractGeneralForm.get('odacalculationmodecode').errors?.ContractRequired">
                                                    Please Select the ODA Calculation Mode
                                                </span>
                                            </td>
                                            <td></td>
                                            <td></td>

                                        </tr>
                                    </table>
                                </form>
                            </p-tabPanel>
                            <p-tabPanel header="Region Level" *ngIf="HideRegionLevel">
                                <form [formGroup]="_RegionLevelForm">
                                    <table class="normal-table">
                                        <!-- <tr>
                                            <td></td>
                                            <td>
                                                <input name="file-upload-field" type="file" #takeRegionLevelInput
                                                    (change)="selectRegionLevelFile($event)" class="file-upload-field"
                                                    placeholder="Upload file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                            </td>
                                            <td colspan="2">
                                                <button pButton label="Validate Uploaded Data"
                                                    (click)="RegionLevelupload()" [disabled]=ValidateRegion
                                                    class="p-button-success"></button>

                                                <a href="assets/Docs/Region Level.xlsx" class="download-link">Download
                                                    Template</a>


                                            </td>
                                        </tr> -->
                                        <tr>
                                            <td class="text-right">From Branch <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="frombranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('frombranchcode').errors?.ContractRegionRequired">
                                                    Please Select the From Branch
                                                </span>
                                            </td>
                                            <td class="text-right">To Region <span class="hlt-txt">*</span></td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="toregioncode"
                                                    placeholder="Select" [filter]="true" [options]="_Region"
                                                    optionLabel="regionname" optionValue="regioncode"></p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('toregioncode').errors?.ContractRegionRequired">
                                                    Please Select the To Region
                                                </span>
                                            </td>
                                            <td class="text-right">Article Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="articlecode"
                                                    placeholder="Select" [filter]="true" [options]="_ArticleName "
                                                    optionLabel="articlename" optionValue="articlecode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('articlecode').errors?.ContractRegionRequired">
                                                    Please Select the Article Name
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Rate Type ( KG / Art) <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="ratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_RegionRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('ratetypecode').errors?.ContractRegionRequired">
                                                    Please Select the Rate Type
                                                </span>
                                            </td>
                                            <td class="text-right">Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <input type="text" formControlName="rate"
                                                    (keypress)="keypress.kpDecimalInput($event)" pInputText>
                                            </td>
                                            <td class="text-right">DC Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" (onChange)="onChangeDCRateType()"
                                                    formControlName="dcratetypecode" placeholder="Select"
                                                    [filter]="true" [options]="_DCRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('dcratetypecode').errors?.ContractRegionRequired">
                                                    Please Enter the DC Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="dcrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDCRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DC Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="dcinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('dcinclusiveorexclusivecode').errors?.ContractRegionRequired">
                                                    Please Select the DC Charges
                                                </span>
                                            </td>
                                            <td class="text-right">DD Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" (onChange)="onChangeDDRateType()"
                                                    formControlName="ddratetypecode" placeholder="Select"
                                                    [filter]="true" [options]="_DDRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('ddratetypecode').errors?.ContractRegionRequired">
                                                    Please Select the DD Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DD Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="ddrate"
                                                        (keypress)="keypress.kpDecimalInput($event)" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDDRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>

                                            <td class="text-right">DD Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="ddinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('ddinclusiveorexclusivecode').errors?.ContractRegionRequired">
                                                    Please Select the DC Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Article Charge Code <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="hidden" formControlName="acratetypecode">
                                                    <input type="text" formControlName="acratetype" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogArticleChargeCode()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('acratetypecode').errors?.ContractRegionRequired">
                                                    Please Select the Article Charge Code
                                                </span>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">AC for Agent<span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="agentacrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogAgentACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC for Customer <span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="customeracrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogCustomerACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="acrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                            <td class="text-right">Add on Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="inclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('inclusiveorexclusivecode').errors?.ContractRegionRequired">
                                                    Please Select the Add on Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Reverse Booking <span class="hlt-txt">*</span>
                                            </td>
                                            <td>


                                                <input type="checkbox" id="isneedreversebooking"
                                                    name="isneedreversebooking" formControlName="isneedreversebooking"
                                                    class="p-checkbox">


                                            </td>

                                        </tr>
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                <!-- <button pButton type="button" label="Update" (click)="updateRowRegion()"
                                                    [hidden]="_updateRowRegion" class="p-button-success"></button>
                                                <button pButton type="button" label="Add" (click)="addRowRegion()"
                                                    [hidden]="_addRowRegion" class="p-button-success"></button> -->
                                                <button pButton label="Clear" (click)="ClearRowRegion()"
                                                    class="p-button-warning"></button>
                                            </td>
                                        </tr>
                                    </table>
                                </form>
                                <p-dialog header="DC Slab Rate in Piece" [(visible)]="displayDCRate"
                                    (onHide)="closeDCRate()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromDCPiece" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToDCPiece" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateDCPiece" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRate()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRate()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCPiece" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action
                                                            </th> -->
                                                            <th pSortableColumn="FromDCPiece">From Piece
                                                                <p-sortIcon field="FromDCPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPiece">To Piece
                                                                <p-sortIcon field="_ToDCPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPiece">Rate
                                                                <p-sortIcon field="_RateDCPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCPieceList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCPiece(_DCPieceList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCPieceList.FromPiece}}</td>
                                                            <td>{{_DCPieceList.ToPiece}}</td>
                                                            <td>{{_DCPieceList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCPieceAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCPieceAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCPieceAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in KG" [(visible)]="displayDCRateKG"
                                    (onHide)="closeDCRateKG()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromDCKG" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToDCKG" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateDCKG" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateKG()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRateKG()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCKG" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKG">From Piece
                                                                <p-sortIcon field="_FromDCKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKG">To Piece
                                                                <p-sortIcon field="_ToDCKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKG">Rate
                                                                <p-sortIcon field="_RateDCKG">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCKGList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCKG(_DCKGList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCKGList.FromPiece}}</td>
                                                            <td>{{_DCKGList.ToPiece}}</td>
                                                            <td>{{_DCKGList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCKGAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCKGAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCKGAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in Piece" [(visible)]="displayDDRate"
                                    (onHide)="closeDDRate()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromDDPiece" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToDDPiece" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateDDPiece" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRate()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRate()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDPiece" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDDPiece">From Piece
                                                                <p-sortIcon field="FromDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDPiece">To Piece
                                                                <p-sortIcon field="_ToDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDPiece">Rate
                                                                <p-sortIcon field="_RateDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDPieceList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDPiece(_DDPieceList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDPieceList.FromPiece}}</td>
                                                            <td>{{_DDPieceList.ToPiece}}</td>
                                                            <td>{{_DDPieceList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDPieceAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDPieceAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDPieceAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in KG" [(visible)]="displayDDRateKG"
                                    (onHide)="closeDDRateKG()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromDDKG" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToDDKG" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateDDKG" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateKG()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRateKG()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDKG" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDDKG">From Piece
                                                                <p-sortIcon field="_FromDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDKG">To Piece
                                                                <p-sortIcon field="_ToDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDKG">Rate
                                                                <p-sortIcon field="_RateDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDKGList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDKG(_DDKGList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDKGList.FromPiece}}</td>
                                                            <td>{{_DDKGList.ToPiece}}</td>
                                                            <td>{{_DDKGList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDKGAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDKGAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDKGAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Rate Type" [(visible)]="displayACRateType" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="search-container">
                                                <div class="p-inputgroup">
                                                    <span class="p-float-label">
                                                        <input type="text" pInputText
                                                            (input)="DTACRateTypeList.filterGlobal($event.target.value, 'contains')"
                                                            placeholder="Search..." />
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <p-table #DTACRateTypeList [value]="_ArticleChargeCode"
                                                    selectionMode="single" [(selection)]="selectedRequest2"
                                                    [globalFilterFields]="['charge_Code','rate']"
                                                    (onRowSelect)="onRowSelectPopupArticleChargeCode($event)"
                                                    [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>

                                                            <th pSortableColumn="charge_Code">Charge Code
                                                                <p-sortIcon field="charge_Code">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="rate">Rate
                                                                <p-sortIcon field="rate">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData
                                                        let-_ArticleChargeCodeList>
                                                        <tr [pSelectableRow]="rowData">

                                                            <td>{{_ArticleChargeCodeList.charge_Code}}</td>
                                                            <td>{{_ArticleChargeCodeList.rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in Piece" [(visible)]="displayACRate"
                                    (onHide)="closeACRate()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromACPiece" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToACPiece" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateACPiece" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRate()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRate()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACPiece" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromACPiece">From Piece
                                                                <p-sortIcon field="FromACPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToACPiece">To Piece
                                                                <p-sortIcon field="_ToACPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateACPiece">Rate
                                                                <p-sortIcon field="_RateACPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACPieceList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACPiece(_ACPieceList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACPieceList.FromPiece}}</td>
                                                            <td>{{_ACPieceList.ToPiece}}</td>
                                                            <td>{{_ACPieceList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideADPieceAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACPieceAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACPieceAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in KG" [(visible)]="displayACRateKG"
                                    (onHide)="closeACRateKG()" [modal]="true" [style]="{width: '50vw',height: '500px'}"
                                    [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_FromACKG" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ToACKG" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_RateACKG" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateKG()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRateKG()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACKG" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Action</th>
                                                            <th pSortableColumn="_FromACKG">From Piece
                                                                <p-sortIcon field="_FromACKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToACKG">To Piece
                                                                <p-sortIcon field="_ToACKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateACKG">Rate
                                                                <p-sortIcon field="_RateACKG">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACKGList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACKG(_ACKGList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACKGList.FromPiece}}</td>
                                                            <td>{{_ACKGList.ToPiece}}</td>
                                                            <td>{{_ACKGList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACKGAdditionalRate">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACKGAdditionalRate"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACKGAdditionalRateMsg">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelRegionList()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_RegionList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','toregion','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <!-- <col style="width:150px"> -->
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th style="text-align: center;width: 100px;" rowspan="2">Action
                                                </th> -->
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="toregion">To Region<p-sortIcon field="toregion">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon field="ratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectivefrom">Effective From
                                                    <p-sortIcon field="effectivefrom">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectiveto">Effective To
                                                    <p-sortIcon field="effectiveto">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelect_RegionList(_RegionListGrid,i)">
                                                <!-- <td style="text-align: center">
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"
                                                        (click)="Remove_RegionList(_RegionListGrid)"
                                                        [disabled]="_action=='view'"></button>
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.toregion}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.addoninclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectivefrom|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectiveto|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Article Based" *ngIf="HideArticleBased">
                                <form [formGroup]="_ArticleBasedForm">
                                    <table class="normal-table">
                                        <!-- <tr>
                                            <td></td>
                                            <td>
                                                <input name="file-upload-field" type="file" #takeArticleBasedInput
                                                    (change)="selectArticleBasedFile($event)" class="file-upload-field"
                                                    placeholder="Upload file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                            </td>
                                            <td colspan="2">
                                                <button pButton label="Validate Uploaded Data"
                                                    (click)="ArticleBasedupload()" [disabled]=ValidateArticle
                                                    class="p-button-success"></button>

                                                <a href="assets/Docs/Article Based.xlsx" class="download-link">Download
                                                    Template</a>


                                            </td>
                                        </tr> -->
                                        <tr>
                                            <td class="text-right">From Branch <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="frombranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('frombranchcode').errors?.ContractArticleRequired">
                                                    Please Select the From Branch
                                                </span>
                                            </td>
                                            <td class="text-right">To Branch <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="tobranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('tobranchcode').errors?.ContractArticleRequired">
                                                    Please Select the From Branch
                                                </span>
                                            </td>
                                            <td class="text-right">Rate Per Quintal/KM <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <input type="number" formControlName="rateperkm" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('rateperkm').errors?.ContractArticleRequired">
                                                    Please Enter Rate Per Quintal/KM
                                                </span>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <td class="text-right">Volumetric Based On <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" placeholder="Select"
                                                    [filter]="true" [options]="_VolBasedOn"
                                                    (onChange)="ChangeVolumetric($event)" optionLabel="volumetricname"
                                                    optionValue="volumetricid">
                                                </p-dropdown>
                                            </td>
                                            <td class="text-right">Article Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="articlecode"
                                                    placeholder="Select" [filter]="true" [options]="_ArticleName"
                                                    optionLabel="articlename" optionValue="articlecode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('articlecode').errors?.ContractArticleRequired">
                                                    Please Select Article Name
                                                </span>
                                            </td>
                                            <!-- <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="articlecode"
                                                    placeholder="Select" [filter]="true" [options]="_ArticleName "
                                                    optionLabel="articlename" optionValue="articlecode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_RegionLevelFormsubmitted) && _RegionLevelForm.get('articlecode').errors?.ContractRegionRequired">
                                                    Please Select the Article Name
                                                </span>
                                            </td> -->
                                            <td class="text-right">Rate Type ( KG / Art) <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="ratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_RateType"
                                                    (onChange)="ChangeArticle($event)" optionLabel="metasubdescription"
                                                    optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('ratetypecode').errors?.ContractArticleRequired">
                                                    Please Select the Rate Type
                                                </span>
                                            </td>
                                            <!-- <td class="text-right">Kg <span class="hlt-txt">*</span></td>
                                            <td>
                                                <input type="number" disabled formControlName="kg" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('kg').errors?.ContractArticleRequired">
                                                    Please Enter the Weight
                                                </span>
                                            </td> -->


                                        </tr>
                                        <tr>
                                            <td class="text-right">Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <input type="number" formControlName="rate" pInputText>
                                            </td>
                                            <td class="text-right">DC Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    (onChange)="onChangeDCRateTypeAB()" formControlName="dcratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_DCRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('dcratetypecode').errors?.ContractArticleRequired">
                                                    Please Select the DC Rate Type
                                                </span>
                                            </td>
                                            <td class="text-right">DC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="dcrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDCRateAB()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>



                                        </tr>
                                        <tr>
                                            <td class="text-right">DC Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="dcinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('dcinclusiveorexclusivecode').errors?.ContractArticleRequired">
                                                    Please Select the DC Charges
                                                </span>
                                            </td>
                                            <td class="text-right">DD Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    (onChange)="onChangeDDRateTypeAB()" formControlName="ddratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_DDRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('ddratetypecode').errors?.ContractArticleRequired">
                                                    Please Select the DD Rate Type
                                                </span>
                                            </td>
                                            <td class="text-right">DD Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="ddrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDDRateAB()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DD Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="ddinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('ddinclusiveorexclusivecode').errors?.ContractArticleRequired">
                                                    Please Select the DD Charges
                                                </span>
                                            </td>
                                            <td class="text-right">Article Charge Code <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="hidden" formControlName="acratetypecode">
                                                    <input type="text" formControlName="acratetype" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogArticleChargeCodeAB()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('acratetypecode').errors?.ContractArticleRequired">
                                                    Please Select the Article Charge Code
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">AC for Agent<span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="agentacrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogAgentACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC for Customer <span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="customeracrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogCustomerACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="acrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogACRateAB()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Add on Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="inclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_ArticleBasedFormsubmitted) && _ArticleBasedForm.get('inclusiveorexclusivecode').errors?.ContractArticleRequired">
                                                    Please Select the Add on Charges
                                                </span>
                                            </td>
                                            <td class="text-right">Reverse Booking <span class="hlt-txt">*</span>
                                            </td>
                                            <td>

                                                <input type="checkbox" id="isneedreversebookingAB"
                                                    name="isneedreversebooking" formControlName="isneedreversebooking"
                                                    class="p-checkbox">

                                            </td>
                                            <td></td>
                                            <td></td>

                                        </tr>
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                <!-- <button pButton type="button" label="Update"
                                                    (click)="updateRowArticleBase()" [hidden]="_updateRowArticleBased"
                                                    class="p-button-success"></button>
                                                <button pButton type="button" label="Add" (click)="addRowArticleBase()"
                                                    [hidden]="_addRowArticleBased" class="p-button-success"></button> -->
                                                <button pButton label="Clear" (click)="ClearRowArticleBase()"
                                                    class="p-button-warning"></button>
                                            </td>
                                        </tr>
                                    </table>
                                </form>
                                <p-dialog header="DC Slab Rate in Piece" (onHide)="closeDCRateAB()"
                                    [(visible)]="displayDCRateAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCPieceAB"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCPieceAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCPieceAB"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRateAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCPieceAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceAB">From Piece
                                                                <p-sortIcon field="FromDCPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceAB">To Piece
                                                                <p-sortIcon field="_ToDCPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceAB">Rate
                                                                <p-sortIcon field="_RateDCPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCPieceABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCPieceAB(_DCPieceABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCPieceABList.FromPiece}}</td>
                                                            <td>{{_DCPieceABList.ToPiece}}</td>
                                                            <td>{{_DCPieceABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCPieceAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCPieceAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCPieceAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in KG" (onHide)="closeDCRateKGAB()"
                                    [(visible)]="displayDCRateKGAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCKGAB" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCKGAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCKGAB" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateKGAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRateKGAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCKGAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGAB">From Piece
                                                                <p-sortIcon field="_FromDCKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGAB">To Piece
                                                                <p-sortIcon field="_ToDCKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGAB">Rate
                                                                <p-sortIcon field="_RateDCKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCKGABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCKGAB(_DCKGABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCKGABList.FromPiece}}</td>
                                                            <td>{{_DCKGABList.ToPiece}}</td>
                                                            <td>{{_DCKGABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCKGAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCKGAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCKGAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in Piece" (onHide)="closeDDRateAB()"
                                    [(visible)]="displayDDRateAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDPieceAB"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDPieceAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDPieceAB"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRateAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDPieceAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Action</th>
                                                            <th pSortableColumn="FromDDPieceAB">From Piece
                                                                <p-sortIcon field="FromDDPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDPieceAB">To Piece
                                                                <p-sortIcon field="_ToDDPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDPieceAB">Rate
                                                                <p-sortIcon field="_RateDDPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDPieceABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDPieceAB(_DDPieceABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDPieceABList.FromPiece}}</td>
                                                            <td>{{_DDPieceABList.ToPiece}}</td>
                                                            <td>{{_DDPieceABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDPieceAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDPieceAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDPieceAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in KG" (onHide)="closeDDRateKGAB()"
                                    [(visible)]="displayDDRateKGAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDKGAB" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDKGAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDKGAB" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateKGAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRateKGAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDKGAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDDKGAB">From Piece
                                                                <p-sortIcon field="_FromDDKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDKGAB">To Piece
                                                                <p-sortIcon field="_ToDDKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDKGAB">Rate
                                                                <p-sortIcon field="_RateDDKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDKGABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDKGAB(_DDKGABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDKGABList.FromPiece}}</td>
                                                            <td>{{_DDKGABList.ToPiece}}</td>
                                                            <td>{{_DDKGABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDKGAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDKGAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDKGAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Rate Type" [(visible)]="displayACRateTypeAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="search-container">
                                                <div class="p-inputgroup">
                                                    <span class="p-float-label">
                                                        <input type="text" pInputText
                                                            (input)="dtACRateTypeABList.filterGlobal($event.target.value, 'contains')"
                                                            placeholder="Search..." />
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <p-table #dtACRateTypeABList [value]="_ArticleChargeCode"
                                                    selectionMode="single" [(selection)]="selectedRequest2"
                                                    [globalFilterFields]="['charge_Code','rate']"
                                                    (onRowSelect)="onRowSelectPopupArticleChargeCodeAB($event)"
                                                    [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>

                                                            <th pSortableColumn="charge_Code">Charge Code
                                                                <p-sortIcon field="charge_Code">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="rate">Rate
                                                                <p-sortIcon field="rate">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData
                                                        let-_ArticleChargeCodeList>
                                                        <tr [pSelectableRow]="rowData">

                                                            <td>{{_ArticleChargeCodeList.charge_Code}}</td>
                                                            <td>{{_ArticleChargeCodeList.rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>

                                <p-dialog header="AC Slab Rate in Piece" (onHide)="closeACRateAB()"
                                    [(visible)]="displayACRateAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACPieceAB"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACPieceAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACPieceAB"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRateAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACPieceAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromACPieceAB">From Piece
                                                                <p-sortIcon field="FromACPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToACPieceAB">To Piece
                                                                <p-sortIcon field="_ToACPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateACPieceAB">Rate
                                                                <p-sortIcon field="_RateACPieceAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACPieceABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACPieceAB(_ACPieceABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACPieceABList.FromPiece}}</td>
                                                            <td>{{_ACPieceABList.ToPiece}}</td>
                                                            <td>{{_ACPieceABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACPieceAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACPieceAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACPieceAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in KG" (onHide)="closeACRateKGAB()"
                                    [(visible)]="displayACRateKGAB" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACKGAB" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACKGAB" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACKGAB" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateKGAB()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRateKGAB()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACKGAB" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromACKGAB">From Piece
                                                                <p-sortIcon field="_FromACKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToACKGAB">To Piece
                                                                <p-sortIcon field="_ToACKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateACKGAB">Rate
                                                                <p-sortIcon field="_RateACKGAB">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACKGABList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACKGAB(_ACKGABList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACKGABList.FromPiece}}</td>
                                                            <td>{{_ACKGABList.ToPiece}}</td>
                                                            <td>{{_ACKGABList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACKGAdditionalRateAB">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACKGAdditionalRateAB"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACKGAdditionalRateMsgAB">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelArticle()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_ArticleBasedList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','tobranch','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="tobranch"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true"
                                        [(selection)]="_Articleselectedrows">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <!-- <col style="width:150px"> -->
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <!--<col style="width:150px">
                                                <col style="width:150px">
                                                 <col style="width:150px">
                                                <col style="width:150px"> -->
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th style="text-align: center;width: 100px;" rowspan="2">
                                                    <p-tableHeaderCheckbox [disabled]="_action == 'view'">
                                                    </p-tableHeaderCheckbox>
                                                </th> -->
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="tobranch">To Branch<p-sortIcon field="tobranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <!-- <th pSortableColumn="rate">Rate Per Quintal/KM<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Distance<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th> -->
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon field="ratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>

                                                <!-- <th pSortableColumn="rate">Discount<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Final Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th> -->
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="efffectivefrom">Effective From
                                                    <p-sortIcon field="efffectivefrom">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="efffectiveto">Effective To
                                                    <p-sortIcon field="efffectiveto">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr>
                                                <!-- <td style="text-align: center">

                                                    <p-tableCheckbox [value]="_RegionListGrid"
                                                        [disabled]="_action == 'view'">
                                                    </p-tableCheckbox>
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.tobranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                <!-- <td>
                                                    {{_RegionListGrid.quintalRateperKM}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.distance}}
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>

                                                <!-- <td pEditableColumn>
                                                    <p-cellEditor>
                                                        <ng-template pTemplate="input">
                                                            <input type="text" [(ngModel)]="_RegionListGrid.discount"
                                                                maxlength="2"
                                                                (keyup)="ChangeDiscountPercentage(_RegionListGrid,$event)"
                                                                pInputText>
                                                        </ng-template>
                                                        <ng-template pTemplate="output">
                                                            {{_RegionListGrid.discount }}
                                                        </ng-template>
                                                    </p-cellEditor>
                                                </td>

                                                <td>
                                                    {{_RegionListGrid.finalrate}}
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.addoninclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectivefrom|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectiveto|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>

                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Slab" *ngIf="HideSlab">
                                <form [formGroup]="_SlabForm">
                                    <table class="normal-table">
                                        <!-- <tr>
                                            <td></td>
                                            <td>
                                                <input name="file-upload-field" type="file" #takeSlabInput
                                                    (change)="selectSlabFile($event)" class="file-upload-field"
                                                    placeholder="Upload file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                            </td>
                                            <td colspan="2">
                                                <button pButton label="Validate Uploaded Data" (click)="Slabupload()"
                                                    [disabled]=ValidateSlab class="p-button-success"></button>

                                                <a href="assets/Docs/Slab.xlsx" class="download-link">Download
                                                    Template</a>


                                            </td>
                                        </tr> -->
                                        <tr>

                                            <td class="text-right">From
                                                Branch <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="frombranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('frombranchcode').errors?.ContractSlabRequired">
                                                    Please Select the From
                                                    Branch
                                                </span>
                                            </td>
                                            <td class="text-right">To Branch
                                                <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="tobranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('tobranchcode').errors?.ContractSlabRequired">
                                                    Please Select the To
                                                    Branch
                                                </span>
                                            </td>
                                            <td class="text-right">Article
                                                Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="articlecode"
                                                    placeholder="Select" [filter]="true" [options]="_ArticleName "
                                                    optionLabel="articlename" optionValue="articlecode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('articlecode').errors?.ContractSlabRequired">
                                                    Please Select the
                                                    Article Name
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Rate Type
                                                ( KG / Art) <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="ratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_SlabType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('ratetypecode').errors?.ContractSlabRequired">
                                                    Please Select the Rate
                                                    Type
                                                </span>
                                            </td>
                                            <td class="text-right">Slab
                                                <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="rate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogSlab()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DC Rate
                                                Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    (onChange)="onChangeDCRateTypeSlab()"
                                                    formControlName="dcratetypecode" placeholder="Select"
                                                    [filter]="true" [options]="_DCRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('dcratetypecode').errors?.ContractSlabRequired">
                                                    Please Select the DC
                                                    Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DC Rate
                                                <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="dcrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDCRateSlab()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DC Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="dcinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('dcinclusiveorexclusivecode').errors?.ContractSlabRequired">
                                                    Please Select the DC
                                                    Charges
                                                </span>
                                            </td>
                                            <td class="text-right">DD Rate
                                                Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    (onChange)="onChangeDDRateTypeSlab()"
                                                    formControlName="ddratetypecode" placeholder="Select"
                                                    [filter]="true" [options]="_DDRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('ddratetypecode').errors?.ContractSlabRequired">
                                                    Please Select the DD
                                                    Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DD Rate
                                                <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="ddrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDDRateSlab()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DD
                                                Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="ddinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('ddinclusiveorexclusivecode').errors?.ContractSlabRequired">
                                                    Please Select the DD
                                                    Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Article
                                                Charge Code <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="hidden" formControlName="acratetypecode">
                                                    <input type="text" formControlName="acratetype" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogArticleChargeCodeSlab()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('acratetypecode').errors?.ContractSlabRequired">
                                                    Please Select the
                                                    Article Charge Code
                                                </span>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">AC for Agent<span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="agentacrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogAgentACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC for Customer <span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="customeracrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogCustomerACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC Rate
                                                <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="acrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogACRateSlab()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                            <td class="text-right">Add on
                                                Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="inclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_SlabFormsubmitted) && _SlabForm.get('inclusiveorexclusivecode').errors?.ContractSlabRequired">
                                                    Please Select the Add on
                                                    Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Reverse
                                                Booking <span class="hlt-txt">*</span>
                                            </td>
                                            <td>

                                                <input type="checkbox" id="isneedreversebookingS"
                                                    name="isneedreversebooking" formControlName="isneedreversebooking"
                                                    class="p-checkbox">

                                            </td>

                                        </tr>
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                <!-- <button pButton type="button" label="update" (click)="updateRowSlab()"
                                                    [hidden]="_updateRowSlab" class="p-button-success"></button>
                                                <button pButton type="button" label="Add" (click)="addRowSlab()"
                                                    [hidden]="_addRowSlab" class="p-button-success"></button> -->
                                                <button pButton label="Clear" (click)="ClearRowSlab()"
                                                    class="p-button-warning"></button>
                                            </td>
                                        </tr>
                                    </table>
                                </form>

                                <p-dialog header="Slab Rate in Piece" [(visible)]="displaySlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromPieceSlab"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToPieceSlab" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RatePieceSlab"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRateSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowRateSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_PieceSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceSlab">From Piece
                                                                <p-sortIcon field="FromDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceSlab">To Piece
                                                                <p-sortIcon field="_ToDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceSlab">Rate
                                                                <p-sortIcon field="_RateDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_PieceSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_PieceSlab(_PieceSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_PieceSlabList.FromPiece}}</td>
                                                            <td>{{_PieceSlabList.ToPiece}}</td>
                                                            <td>{{_PieceSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="Slab Rate in KG" [(visible)]="displayKGSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromKGSlab" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToKGSlab" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateKGSlab" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRateKGSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowRateKGSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_KGSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_KGSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_KGSlab(_KGSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_KGSlabList.FromPiece}}</td>
                                                            <td>{{_KGSlabList.ToPiece}}</td>
                                                            <td>{{_KGSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in Piece" (onHide)="closeDCRateSP()"
                                    [(visible)]="displayDCRateSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCPieceSlab"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCPieceSlab"
                                                                pInputText></td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCPieceSlab"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRateSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCPieceSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceSlab">From Piece
                                                                <p-sortIcon field="FromDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceSlab">To Piece
                                                                <p-sortIcon field="_ToDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceSlab">Rate
                                                                <p-sortIcon field="_RateDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCPieceSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCPieceSlab(_DCPieceSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCPieceSlabList.FromPiece}}</td>
                                                            <td>{{_DCPieceSlabList.ToPiece}}</td>
                                                            <td>{{_DCPieceSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCPieceAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCPieceAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCPieceAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in KG" (onHide)="closeDCRateKGSP()"
                                    [(visible)]="displayDCRateKGSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCKGSlab" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCKGSlab" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCKGSlab" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateKGSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowDCRateKGSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCKGSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCKGSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCKGSlab(_DCKGSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCKGSlabList.FromPiece}}</td>
                                                            <td>{{_DCKGSlabList.ToPiece}}</td>
                                                            <td>{{_DCKGSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCKGAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCKGAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCKGAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in Piece" (onHide)="closeDDRateSP()"
                                    [(visible)]="displayDDRateSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDPieceSlab"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDPieceSlab"
                                                                pInputText></td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDPieceSlab"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRateSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDPieceSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDDPiece">From Piece
                                                                <p-sortIcon field="FromDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDPiece">To Piece
                                                                <p-sortIcon field="_ToDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDPiece">Rate
                                                                <p-sortIcon field="_RateDDPiece">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDPieceSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDPieceSlab(_DDPieceSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDPieceSlabList.FromPiece}}</td>
                                                            <td>{{_DDPieceSlabList.ToPiece}}</td>
                                                            <td>{{_DDPieceSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDPieceAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDPieceAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDPieceAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in KG" (onHide)="closeDDRateKGSP()"
                                    [(visible)]="displayDDRateKGSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDKGSlab" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDKGSlab" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDKGSlab" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateKGSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowDDRateKGSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDKGSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDDKG">From Piece
                                                                <p-sortIcon field="_FromDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDKG">To Piece
                                                                <p-sortIcon field="_ToDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDKG">Rate
                                                                <p-sortIcon field="_RateDDKG">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDKGSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDKGSlab(_DDKGSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDKGSlabList.FromPiece}}</td>
                                                            <td>{{_DDKGSlabList.ToPiece}}</td>
                                                            <td>{{_DDKGSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDKGAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDKGAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDKGAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in Piece" (onHide)="closeACRateSP()"
                                    [(visible)]="displayACRateSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACPieceSlab"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACPieceSlab"
                                                                pInputText></td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACPieceSlab"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRateSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACPieceSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceSlab">From Piece
                                                                <p-sortIcon field="FromDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceSlab">To Piece
                                                                <p-sortIcon field="_ToDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceSlab">Rate
                                                                <p-sortIcon field="_RateDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACPieceSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACPieceSlab(_ACPieceSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACPieceSlabList.FromPiece}}</td>
                                                            <td>{{_ACPieceSlabList.ToPiece}}</td>
                                                            <td>{{_ACPieceSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACPieceAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACPieceAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACPieceAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in KG" (onHide)="closeACRateKGSP()"
                                    [(visible)]="displayACRateKGSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACKGSlab" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACKGSlab" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACKGSlab" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateKGSlab()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowACRateKGSlab()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACKGSlab" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACKGSlabList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACKGSlab(_ACKGSlabList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACKGSlabList.FromPiece}}</td>
                                                            <td>{{_ACKGSlabList.ToPiece}}</td>
                                                            <td>{{_ACKGSlabList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACKGAdditionalRateSP">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACKGAdditionalRateSP"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACKGAdditionalRateMsgSP">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Rate Type" [(visible)]="displayACRateTypeSlab" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="search-container">
                                                <div class="p-inputgroup">
                                                    <span class="p-float-label">
                                                        <input type="text" pInputText
                                                            (input)="dtACRateTypeSlabList.filterGlobal($event.target.value, 'contains')"
                                                            placeholder="Search..." />
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <p-table #dtACRateTypeSlabList [value]="_ArticleChargeCode"
                                                    selectionMode="single" [(selection)]="selectedRequest2"
                                                    [globalFilterFields]="['charge_Code','rate']"
                                                    (onRowSelect)="onRowSelectPopupArticleChargeCodeSlab($event)"
                                                    [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>

                                                            <th pSortableColumn="charge_Code">Charge Code
                                                                <p-sortIcon field="charge_Code">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="rate">Rate
                                                                <p-sortIcon field="rate">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData
                                                        let-_ArticleChargeCodeSlabList>
                                                        <tr [pSelectableRow]="rowData">
                                                            <td>{{_ArticleChargeCodeSlabList.charge_Code}}</td>
                                                            <td>{{_ArticleChargeCodeSlabList.rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelSlab()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_SlabFormList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','tobranch','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <!-- <col style="width:150px"> -->
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th style="text-align: center;width: 100px;" rowspan="2">Action
                                                </th> -->
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="tobranch">To Branch<p-sortIcon field="tobranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon field="ratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectivefrom">Effective From
                                                    <p-sortIcon field="effectivefrom">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectiveto">Effective To
                                                    <p-sortIcon field="effectiveto">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelect_SlabFormList(_RegionListGrid, i)">
                                                <!-- <td style="text-align: center">

                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"></button>
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.tobranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectivefrom|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.effectiveto|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>


                            </p-tabPanel>
                            <p-tabPanel header="2D Rate" *ngIf="Hide2DRate">
                                <form [formGroup]="_2DForm">
                                    <table class="normal-table">
                                        <!-- <tr>
                                            <td></td>
                                            <td>
                                                <input name="file-upload-field" type="file" #take2drateInput
                                                    (change)="select2DRateFile($event)" class="file-upload-field"
                                                    placeholder="Upload file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                            </td>
                                            <td colspan="2">
                                                <button pButton label="Validate Uploaded Data"
                                                    (click)="TwoDRateupload()" [disabled]=ValidateDD
                                                    class="p-button-success"></button>

                                                <a href="assets/Docs/2D Rate.xlsx" class="download-link">Download
                                                    Template</a>
                                            </td>
                                        </tr> -->
                                        <tr>
                                            <td class="text-right">From Branch <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="frombranchcode"
                                                    placeholder="Select" [filter]="true" [options]="_BillingBranch"
                                                    optionLabel="branchname" optionValue="branchcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('frombranchcode').errors?.Contract2DRequired">
                                                    Please Select the From Branch
                                                </span>
                                            </td>
                                            <td class="text-right">To KM <span class="hlt-txt">*</span></td>
                                            <td>
                                                <input type="text" formControlName="toKM" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('toKM').errors?.Contract2DRequired">
                                                    Please Enter the To KM
                                                </span>
                                            </td>
                                            <td class="text-right">Article Name <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="articlecode"
                                                    placeholder="Select" [filter]="true" [options]="_ArticleName "
                                                    optionLabel="articlename" optionValue="articlecode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('articlecode').errors?.Contract2DRequired">
                                                    Please Select the Article Name
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Rate Type ( KG / Art) <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="ratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_SlabType2D"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('ratetypecode').errors?.Contract2DRequired">
                                                    Please Select the Rate Type
                                                </span>
                                            </td>
                                            <td class="text-right">Slab <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="rate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogSlabRate2D()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DC Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" (onChange)="onChangeDCRateType()"
                                                    formControlName="dcratetypecode" placeholder="Select"
                                                    [filter]="true" [options]="_DCRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('dcratetypecode').errors?.Contract2DRequired">
                                                    Please Select the DC Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="dcrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDCRate2D()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DC Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="dcinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('dcinclusiveorexclusivecode').errors?.Contract2DRequired">
                                                    Please Select the DC Charges
                                                </span>
                                            </td>
                                            <td class="text-right">DD Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    (onChange)="onChangeDDRateType2D()" formControlName="ddratetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_DDRateType"
                                                    optionLabel="metasubdescription" optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('ddratetypecode').errors?.Contract2DRequired">
                                                    Please Select the DD Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">DD Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="ddrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogDDRate2D()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">DD Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="ddinclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('ddinclusiveorexclusivecode').errors?.Contract2DRequired">
                                                    Please Select the DD Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Article Charge Code <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="hidden" formControlName="acratetypecode">
                                                    <input type="text" formControlName="acratetype" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogArticleChargeCode2D()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('acratetypecode').errors?.Contract2DRequired">
                                                    Please Select the Article Charge Code
                                                </span>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">AC for Agent<span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="agentacrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogAgentACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC for Customer <span class="hlt-txt">*</span></td>
                                            <td>
                                                <!--input type="text" formControlName="acrate" pInputText-->
                                                <div class="p-inputgroup">
                                                    <input type="number" (ngModelChange)="ChangeACforCustomer($event,'region')" [attr.disabled]="isSlabACDisable ? true: null" formControlName="customeracrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogCustomerACRate()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">AC Rate <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="acrate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogACRate2D()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                            <td class="text-right">Add on Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="inclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_2DFormsubmitted) && _2DForm.get('inclusiveorexclusivecode').errors?.Contract2DRequired">
                                                    Please Select the Add on Charges
                                                </span>
                                            </td>

                                            <td class="text-right">Reverse Booking <span class="hlt-txt">*</span>
                                            </td>
                                            <td>

                                                <input type="checkbox" id="isneedreversebooking2D"
                                                    name="isneedreversebooking" formControlName="isneedreversebooking"
                                                    class="p-checkbox">

                                            </td>

                                        </tr>
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                <!-- <button pButton type="button" label="Update" (click)="updateRow2D()"
                                                    [hidden]="_updateRow2D" class="p-button-success"></button>
                                                <button pButton type="button" label="Add" (click)="addRow2D()"
                                                    [hidden]="_addRow2D" class="p-button-success"></button> -->
                                                <button pButton label="Clear" (click)="ClearRow2D()"
                                                    class="p-button-warning"></button>
                                            </td>
                                        </tr>
                                    </table>
                                </form>
                                <p-dialog header="2D Slab Rate in Piece" [(visible)]="display2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromPiece2D" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToPiece2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RatePiece2D" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRate2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowRate2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_Piece2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceSlab">From Piece
                                                                <p-sortIcon field="FromDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceSlab">To Piece
                                                                <p-sortIcon field="_ToDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceSlab">Rate
                                                                <p-sortIcon field="_RateDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_Piece2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_Piece2D(_Piece2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_Piece2DList.FromPiece}}</td>
                                                            <td>{{_Piece2DList.ToPiece}}</td>
                                                            <td>{{_Piece2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="2D Slab Rate in KG" [(visible)]="displayKG2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromKG2D" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToKG2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateKG2D" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRateKG2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowRateKG2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_KG2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_KG2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_KG2D(_KG2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_KG2DList.FromPiece}}</td>
                                                            <td>{{_KG2DList.ToPiece}}</td>
                                                            <td>{{_KG2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in Piece" (onHide)="closeDCRate2D()"
                                    [(visible)]="displayDCRate2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCPiece2D"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCPiece2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCPiece2D"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRate2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRate2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCPiece2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPiece2D">From Piece
                                                                <p-sortIcon field="FromDCPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPiece2D">To Piece
                                                                <p-sortIcon field="_ToDCPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPiece2D">Rate
                                                                <p-sortIcon field="_RateDCPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCPiece2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCPiece2D(_DCPiece2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCPiece2DList.FromPiece}}</td>
                                                            <td>{{_DCPiece2DList.ToPiece}}</td>
                                                            <td>{{_DCPiece2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCPieceAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCPieceAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCPieceAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DC Slab Rate in KG" (onHide)="closeDCRateKG2D()"
                                    [(visible)]="displayDCRateKG2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDCKG2D" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDCKG2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDCKG2D" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDCRateKG2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDCRateKG2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DCKG2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKG2D">From Piece
                                                                <p-sortIcon field="_FromDCKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKG2D">To Piece
                                                                <p-sortIcon field="_ToDCKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKG2D">Rate
                                                                <p-sortIcon field="_RateDCKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DCKG2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DCKG2D(_DCKG2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DCKG2DList.FromPiece}}</td>
                                                            <td>{{_DCKG2DList.ToPiece}}</td>
                                                            <td>{{_DCKG2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDCKGAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DCKGAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDCKGAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in Piece" (onHide)="closeDDRate2D()"
                                    [(visible)]="displayDDRate2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDPiece2D"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDPiece2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDPiece2D"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRate2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRate2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDPiece2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDDPiece2D">From Piece
                                                                <p-sortIcon field="FromDDPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDPiece2D">To Piece
                                                                <p-sortIcon field="_ToDDPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDPiece2D">Rate
                                                                <p-sortIcon field="_RateDDPiece2D">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDPiece2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDPiece2D(_DDPiece2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDPiece2DList.FromPiece}}</td>
                                                            <td>{{_DDPiece2DList.ToPiece}}</td>
                                                            <td>{{_DDPiece2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDPieceAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDPieceAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDPieceAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="DD Slab Rate in KG" (onHide)="closeDDRateKG2D()"
                                    [(visible)]="displayDDRateKG2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromDDKG2D" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToDDKG2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateDDKG2D" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowDDRateKG2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowDDRateKG2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_DDKG2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDDKG2D">From Piece
                                                                <p-sortIcon field="_FromDDKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDDKG2D">To Piece
                                                                <p-sortIcon field="_ToDDKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDDKG2D">Rate
                                                                <p-sortIcon field="_RateDDKG2D">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_DDKG2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_DDKG2D(_DDKG2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_DDKG2DList.FromPiece}}</td>
                                                            <td>{{_DDKG2DList.ToPiece}}</td>
                                                            <td>{{_DDKG2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideDDKGAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_DDKGAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideDDKGAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in Piece" (onHide)="closeACRate2D()"
                                    [(visible)]="displayACRate2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACPiece2D"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACPiece2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACPiece2D"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRate2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRate2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACPiece2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Action</th>
                                                            <th pSortableColumn="FromDCPieceSlab">From Piece
                                                                <p-sortIcon field="FromDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceSlab">To Piece
                                                                <p-sortIcon field="_ToDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceSlab">Rate
                                                                <p-sortIcon field="_RateDCPieceSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACPiece2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACPiece2D(_ACPiece2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACPiece2DList.FromPiece}}</td>
                                                            <td>{{_ACPiece2DList.ToPiece}}</td>
                                                            <td>{{_ACPiece2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACPieceAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACPieceAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACPieceAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Slab Rate in KG" (onHide)="closeACRateKG2D()"
                                    [(visible)]="displayACRateKG2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromACKG2D" pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToACKG2D" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateACKG2D" pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowACRateKG2D()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear" (click)="ClearRowACRateKG2D()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_ACKG2D" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_ACKG2DList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_ACKG2D(_ACKG2DList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_ACKG2DList.FromPiece}}</td>
                                                            <td>{{_ACKG2DList.ToPiece}}</td>
                                                            <td>{{_ACKG2DList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                                <table class="normal-table" [hidden]="HideACKGAdditionalRate2D">
                                                    <tr>
                                                        <td>Additional Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="text" [(ngModel)]="_ACKGAdditionalRate2D"
                                                                pInputText>
                                                            <span style="color: red;"
                                                                [hidden]="HideACKGAdditionalRateMsg2D">Please
                                                                Enter the Additional Rate</span>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="AC Rate Type" [(visible)]="displayACRateType2D" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="search-container">
                                                <div class="p-inputgroup">
                                                    <span class="p-float-label">
                                                        <input type="text" pInputText
                                                            (input)="dtACRateType2DList.filterGlobal($event.target.value, 'contains')"
                                                            placeholder="Search..." />
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <p-table #dtACRateType2DList [value]="_ArticleChargeCode"
                                                    selectionMode="single" [(selection)]="selectedRequest2"
                                                    [globalFilterFields]="['charge_Code','rate']"
                                                    (onRowSelect)="onRowSelectPopupArticleChargeCode2D($event)"
                                                    [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>

                                                            <th pSortableColumn="charge_Code">Charge Code
                                                                <p-sortIcon field="charge_Code">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="rate">Rate
                                                                <p-sortIcon field="rate">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData
                                                        let-_ArticleChargeCodeList>
                                                        <tr [pSelectableRow]="rowData">

                                                            <td>{{_ArticleChargeCodeList.charge_Code}}</td>
                                                            <td>{{_ArticleChargeCodeList.rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcel2DList()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_2DList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','toregion','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <!-- <col style="width:150px"> -->
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th style="text-align: center;width: 100px;" rowspan="2">Action
                                                </th> -->
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="toregion">To KM<p-sortIcon field="toregion">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon field="ratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>

                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectivefrom">Effective from
                                                    <p-sortIcon field="effectivefrom">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="effectiveto">Effective To
                                                    <p-sortIcon field="effectiveto">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_2DListGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelect_2DList(_2DListGrid, i)">
                                                <!-- <td style="text-align: center">
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"
                                                        (click)="Remove_2DListGrid(_2DListGrid)"
                                                        [disabled]="_action=='view'"></button>
                                                </td> -->
                                                <td>
                                                    {{_2DListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.toKM}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.rate}}
                                                </td>

                                                <td>
                                                    {{_2DListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.addoninclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.effectivefrom|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.effectiveto|date:'dd/MM/yyyy'}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Waybill Heads / Other Charges">
                                <form [formGroup]="_WaybillForm">
                                    <table class="normal-table">

                                        <tr>
                                            <td class="text-right">Charges Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" formControlName="chargetypecode"
                                                    placeholder="Select" [filter]="true" [options]="_AddOnChargeType"
                                                    optionLabel="chargeName" optionValue="chargeCode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_WaybillFormsubmitted) && _WaybillForm.get('chargetypecode').errors?.Contract2DRequired">
                                                    Please Select the Charges Type
                                                </span>
                                            </td>
                                            <td class="text-right">Charge Code
                                            </td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="text" formControlName="chargecodeid" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogRateTypeWayBill()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">Charge Rate Type <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false" placeholder="Select"
                                                    (onChange)="onChangechargeratetypecode()"
                                                    formControlName="chargeratetypecode" [filter]="true"
                                                    [options]="_AddonCharges" optionLabel="metasubdescription"
                                                    optionValue="metasubcode">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_WaybillFormsubmitted) && _WaybillForm.get('chargeratetypecode').errors?.Contract2DRequired">
                                                    Please Select the Charge Rate Type
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right">Value <span class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-inputgroup">
                                                    <input type="number" formControlName="rate" pInputText>
                                                    <button class="p-inputgroup-addon p-button" title="Add"
                                                        type="button" (click)="showBasicDialogValue()">
                                                        <i class="las la-search"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-right">Inclusive/Exclusive <span class="hlt-txt">*</span>
                                            </td>
                                            <td>
                                                <p-dropdown [autoDisplayFirst]="false"
                                                    formControlName="inclusiveorexclusivecode" placeholder="Select"
                                                    [filter]="true" [options]="_InclusiveExclusive"
                                                    optionValue="metasubcode" optionLabel="metasubdescription">
                                                </p-dropdown>
                                                <span class="text-danger"
                                                    *ngIf="(_WaybillFormsubmitted) && _WaybillForm.get('inclusiveorexclusivecode').errors?.Contract2DRequired">
                                                    Please Select the Inclusive/Exclusive
                                                </span>
                                            </td>
                                            <td class="text-right">Print in Other Charges <span class="hlt-txt">*</span>
                                            </td>
                                            <td>

                                                <input type="checkbox" id="printinothercharge" name="printinothercharge"
                                                    formControlName="printinothercharge" class="p-checkbox">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                <!-- <button pButton type="button" label="update"
                                                    [hidden]="_updateRowWayBill" (click)="updateRowWaybill()"
                                                    class="p-button-success"></button>
                                                <button pButton type="button" label="Add" [hidden]="_addRowWayBill"
                                                    (click)="addRowWaybill()" class="p-button-success"></button> -->
                                                <button pButton label="Clear" (click)="ClearRowWaybill()"
                                                    class="p-button-warning"></button>
                                            </td>
                                        </tr>
                                    </table>
                                </form>
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="ExportExcelWaybill()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="WayBillList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['chargecodeName','chargeratetype','adrate','inclusiveorexclusive','printinothercharge']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true">

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th>Action</th> -->
                                                <th pSortableColumn="chargecodeName">Charges type<p-sortIcon
                                                        field="chargecodeName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="chargeratetype">Charges Code<p-sortIcon
                                                        field="chargeratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="chargetype">Charge Rate Type
                                                    <p-sortIcon field="chargetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="adrate">Value <p-sortIcon field="adrate">
                                                    </p-sortIcon>
                                                </th>

                                                <th pSortableColumn="inclusiveorexclusive">Inclusive / exclusive
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="printinothercharge">Print in Other Charges
                                                    <p-sortIcon field="printinothercharge">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_WayBillListGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelectWayBill(_WayBillListGrid, i)">
                                                <!-- <td style="text-align: center">
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"
                                                        (click)="RemoveWayBillList(_WayBillListGrid)"
                                                        [disabled]="_action=='view'"></button>
                                                </td> -->

                                                <td>
                                                    {{_WayBillListGrid.chargetype}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.chargecodeid}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.chargeratetype}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.printinothercharge}}
                                                </td>

                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>

                                <p-dialog header="Rate Type" [(visible)]="displayRateTypeWayBill" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">
                                            <div class="search-container">
                                                <div class="p-inputgroup">
                                                    <span class="p-float-label">
                                                        <input type="text" pInputText
                                                            (input)="dtRateTypeWayBillList.filterGlobal($event.target.value, 'contains')"
                                                            placeholder="Search..." />
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <p-table #dtRateTypeWayBillList [value]="_ArticleChargeCode"
                                                    selectionMode="single" [(selection)]="selectedRequest2"
                                                    [globalFilterFields]="['charge_Code','rate']"
                                                    (onRowSelect)="onRowSelectPopupArticleChargeCodeWayBill($event)"
                                                    [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>

                                                            <th pSortableColumn="requestno" disable>Charge Type
                                                                <p-sortIcon field="requestno">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="charge_Code">Charge Code
                                                                <p-sortIcon field="charge_Code">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="rate">Rate
                                                                <p-sortIcon field="rate">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData
                                                        let-_ArticleChargeCodeList>
                                                        <tr [pSelectableRow]="rowData">

                                                            <td disable>{{_ArticleChargeCodeList.rate_Type}}
                                                            </td>
                                                            <td>{{_ArticleChargeCodeList.charge_Code}}</td>
                                                            <td>{{_ArticleChargeCodeList.rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="Slab Rate in Piece" [(visible)]="displayPieceWayBill" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromPieceWayBill"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToPieceWayBill"
                                                                pInputText></td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RatePieceWayBill"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRateWayBill()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowRateWayBill()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_PieceWayBill" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="FromDCPieceWayBill">From Piece
                                                                <p-sortIcon field="FromDCPieceWayBill">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCPieceWayBill">To Piece
                                                                <p-sortIcon field="_ToDCPieceWayBill">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCPieceWayBill">Rate
                                                                <p-sortIcon field="_RateDCPieceWayBill">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_PieceWayBillList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_PieceWayBill(_PieceWayBillList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_PieceWayBillList.FromPiece}}</td>
                                                            <td>{{_PieceWayBillList.ToPiece}}</td>
                                                            <td>{{_PieceWayBillList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="Slab Rate in KG" [(visible)]="displayKGWayBill" [modal]="true"
                                    [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromKGWayBill"
                                                                pInputText></td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToKGWayBill" pInputText>
                                                        </td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RateKGWayBill"
                                                                pInputText></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add" (click)="addRowRateKGWayBill()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowRateKGWayBill()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_KGWayBill" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_KGWayBillList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_KGWayBill(_KGWayBillList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_KGWayBillList.FromPiece}}</td>
                                                            <td>{{_KGWayBillList.ToPiece}}</td>
                                                            <td>{{_KGWayBillList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                                <p-dialog header="Slab Rate in Piece and KG" [(visible)]="displayPieceKGWayBill"
                                    [modal]="true" [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                                    <ng-template pTemplate="content">
                                        <div class="popup-body">

                                            <div class="card">
                                                <table class="normal-table">
                                                    <tr>
                                                        <td>From Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_FromPieceKGWayBill"
                                                                pInputText>
                                                        </td>
                                                        <td>To Piece <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_ToPieceKGWayBill"
                                                                pInputText></td>
                                                        <td>Rate <span class="hlt-txt">*</span></td>
                                                        <td><input type="number" [(ngModel)]="_RatePieceKGWayBill"
                                                                pInputText>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-center">
                                                            <!-- <button pButton label="Add"
                                                                (click)="addRowRatePieceKGWayBill()"
                                                                class="p-button-success"></button> -->
                                                            <button pButton label="Clear"
                                                                (click)="ClearRowRatePieceKGWayBill()"
                                                                class="p-button-warning"></button>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <p-table [value]="_PieceKGWayBill" selectionMode="single"
                                                    [(selection)]="selectedRequest1" [paginator]="true" [rows]="10">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <!-- <th>Action</th> -->
                                                            <th pSortableColumn="_FromDCPieceKGSlab">From Piece
                                                                <p-sortIcon field="_FromDCPieceKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_ToDCKGSlab">To Piece
                                                                <p-sortIcon field="_ToDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                            <th pSortableColumn="_RateDCKGSlab">Rate
                                                                <p-sortIcon field="_RateDCKGSlab">
                                                                </p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-_PieceKGWayBillList
                                                        let-i="rowIndex">
                                                        <tr [pSelectableRow]="rowData">
                                                            <!-- <td style="text-align: center">
                                                                <button pButton pRipple title="Remove"
                                                                    icon="pi pi-trash" class="p-button-danger p-mr-2"
                                                                    (click)="Remove_PieceKGWayBill(_PieceKGWayBillList)"
                                                                    [disabled]="_action=='view'"></button>
                                                            </td> -->
                                                            <td>{{_PieceKGWayBillList.FromPiece}}</td>
                                                            <td>{{_PieceKGWayBillList.ToPiece}}</td>
                                                            <td>{{_PieceKGWayBillList.Rate}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dialog>
                            </p-tabPanel>
                            <p-tabPanel header="Approval Comments">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <!-- <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="ExportExcelWaybill()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template> -->
                                    </p-toolbar>
                                    <p-table #dt [value]="ApprovalCommentsList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['requestdate','israteincreased','rateincreasedate','approveddate','salesremarks','shremarks','fhremarks','edremarks']"                                 [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true">

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <!-- <th>Action</th> -->
                                                <th pSortableColumn="requestdate">Request Date<p-sortIcon
                                                        field="requestdate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="israteincreased">Is Rate Increased<p-sortIcon
                                                        field="israteincreased">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rateincreasedate">Rate Increase Date
                                                    <p-sortIcon field="rateincreasedate"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="approveddate">Approved Date <p-sortIcon field="approveddate">
                                                    </p-sortIcon>
                                                </th>

                                                <th pSortableColumn="salesremarks">Sales
                                                    <p-sortIcon field="salesremarks">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="shremarks">Sales Head
                                                    <p-sortIcon field="shremarks">
                                                    </p-sortIcon>
                                                </th>



                                                <th pSortableColumn="fhremarks">Finance Head
                                                    <p-sortIcon field="fhremarks">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="edremarks">Executive Director
                                                    <p-sortIcon field="edremarks">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_ApprovalCommentsGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelectWayBill(_ApprovalCommentsGrid, i)">
                                                <!-- <td style="text-align: center">
                                                    <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                        class="p-button-danger p-mr-2"
                                                        (click)="RemoveWayBillList(_ApprovalCommentsGrid)"
                                                        [disabled]="_action=='view'"></button>
                                                </td> -->

                                                <td>
                                                    {{_ApprovalCommentsGrid.requestdate}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.israteincreased}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.rateincreasedate}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.approveddate}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.salesremarks}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.shremarks}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.fhremarks}}
                                                </td>
                                                <td>
                                                    {{_ApprovalCommentsGrid.edremarks}}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                        </p-tabView>

                        <table  class="normal-table">
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="2" class="text-center"> 
                                <!-- <button pButton label="Submit" class="p-button-success"
                                (click)="CustomerContractSubmit()"></button> -->
                                <button pButton label="Clear" class="p-button-warning"
                                (click)="SubmitClear()"></button></td>
                            <td colspan="2"></td>
                        </tr>
                        </table>

                    </div>

                    <!-- form Contract End -->

                </div>
            </div>
        </div>
    </div>
</div>